import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  input,
  linkedSignal,
  signal,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-expandable-text',
  templateUrl: './expandable-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col items-start gap-1' },
})
export class ExpandableTextComponent {
  readonly text = input.required<string>();

  readonly expanded = linkedSignal({
    source: this.text,
    computation: () => false,
  });
  readonly overflowing = signal(false);

  private readonly body = viewChild.required<ElementRef<HTMLElement>>('body');

  constructor() {
    afterRenderEffect(onCleanup => {
      this.text();
      if (this.expanded()) return;
      const el = this.body().nativeElement;
      const measure = () =>
        this.overflowing.set(el.scrollHeight > el.clientHeight);
      measure();

      if (typeof ResizeObserver === 'undefined') return;
      const observer = new ResizeObserver(measure);
      observer.observe(el);
      onCleanup(() => observer.disconnect());
    });
  }

  toggle(): void {
    this.expanded.update(expanded => !expanded);
  }
}
